export default __webpack_public_path__ + "static/media/sports.e52a53e3.svg";